import { styled } from '@mui/material';

import velocity from './velocity.png';

const StyledImg = styled('img')(({ theme }) => ({
  width: theme.spacing(10),
  height: theme.spacing(10),
}));

export const VelocityIcon = () => <StyledImg src={velocity} alt="Velocity" />;
